import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { gallery } from '@/lib/images';
import AboutSection from '@/components/AboutSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative py-20 bg-swastik-lightEarth/20">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-swastik-blue mb-6">About Us</h1>
              <p className="text-lg text-gray-600">
                Discover our journey of healing and wellness through natural methods.
              </p>
            </div>
          </div>
        </section>

        {/* About Section */}
        <AboutSection />

        {/* Team Section */}
        <section className="py-16 md:py-24 bg-swastik-lightEarth/30">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h2 className="section-title mx-auto after:left-1/2 after:-translate-x-1/2">Meet Our Specialists</h2>
              <p className="section-subtitle">
                Our team of certified Ayurvedic physicians brings decades of experience in treating chronic conditions with natural methods.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src={gallery.team[0]}
                  alt="Dr. P. Loganathan BNYS"
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-swastik-blue">Dr. P. Loganathan BNYS</h3>
                  <p className="text-swastik-green">Founder & Chief Physician | Yoga & Naturopathy | Chiropractic Specialist</p>
                  <p className="text-gray-600 mt-2">
                  Founder and chief physician, Dr. Loganathan blends Naturopathy, Yoga, and Chiropractic care to deliver drug-free, holistic treatments that align body and mind.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src={gallery.team[1]}
                  alt="Dr"
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-swastik-blue">Dr.Shymala BSMS</h3>
                  <p className="text-swastik-green">Siddha Physician</p>
                  <p className="text-gray-600 mt-2">
                  With expertise in Siddha and Bio Varma, Dr. Shymala provides personalized, natural treatments focused on activating the body’s healing energy through Varma points.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src={gallery.team[2]}
                  alt="Dr"
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-swastik-blue">Dr.Nivetha BSMS</h3>
                  <p className="text-swastik-green">Siddha Physician</p>
                  <p className="text-gray-600 mt-2">
                  Specialized in Siddha medicine and Bio Varma therapy, Dr. Nivetha offers holistic healing by stimulating vital Varma points to restore balance and wellness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;
